import { useSearchParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const [params] = useSearchParams();
  const err = params.get("error");
  const redirectUrl = (typeof window !== "undefined" ? window.location.origin : "") + "/admin";
  const authUrl = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  return (
    <div className="pt-32 pb-16 max-w-md mx-auto px-4 text-center">
      <ShieldCheck className="w-10 h-10 text-amber-600 mx-auto" />
      <h1 className="mt-4 text-3xl font-bold text-slate-900">Admin sign in</h1>
      <p className="mt-2 text-slate-600">Only authorized emails can access the bench console.</p>
      {err && <p className="mt-3 text-sm text-rose-600" data-testid="admin-login-error">{err.replace(/_/g, " ")}</p>}
      <a
        href={authUrl}
        data-testid="admin-google-btn"
        className="mt-6 w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-slate-900 text-white font-semibold hover:bg-slate-800 no-underline"
      >
        Continue with Google
      </a>
    </div>
  );
}
